/**
 * Timing and Polling Configuration Constants
 */

export const POLLING_INTERVALS = {
  /**
   * Public schedule polling interval (30 seconds)
   * Matches existing ViewerWrapper pattern for consistency
   */
  PUBLIC_SCHEDULE: 30000,

  /**
   * Public standings polling interval (2 minutes)
   * Standings data changes less frequently than live schedule data, so a longer
   * interval reduces server load without meaningfully impacting data freshness.
   */
  PUBLIC_STANDINGS: 120000,

  /**
   * Default polling interval for other features (30 seconds)
   */
  DEFAULT: 30000,
} as const;

export const TIMEOUTS = {
  /**
   * Default API request timeout (10 seconds)
   */
  API_REQUEST: 10000,

  /**
   * Default timeout fallback (5 seconds)
   */
  DEFAULT: 5000,
} as const;
